import { Component, Input, AfterViewInit, OnInit} from '@angular/core';
import { FormBuilder, FormArray, FormGroup, FormControl, Validators} from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AuthenticationService } from 'app/services/authentication.service';
import { AdministrationService } from 'app/services/administration.service';
import { ConsumeService } from 'app/services/consume.service';
import { AlertService } from 'app/utils/alert.service';
import { BindComponentService } from 'app/utils/bind.component.service';
import { SaveConsumeComponent } from 'app/home/paraEmpresas/consume/save/content.component';
import { RemoveGroupConsumeComponent } from 'app/home/paraEmpresas/consume/remove/content.component';
import { MoveLineConsumeComponent } from 'app/home/paraEmpresas/consume/move/content.component';
import { MoveLineConfirmationComponent } from 'app/home/paraEmpresas/consume/move/content.confirmation.component';
import { EditQuotaLinesComponent } from 'app/home/paraEmpresas/consume/editQuotaLines/content.component';
import { EditQuotaLinesComponentData5G } from 'app/home/paraEmpresas/consume/data5G/editQuotaLines/content.component';
import { EditNotifLinesComponent } from 'app/home/paraEmpresas/consume/data/editNotifConsLines/content.component';
import { ConsumeView } from 'app/models/consumeView.model';
import { DataPackCompanyDetail } from 'app/models/dataPackCompanyDetail.model';
import { DataPackGroup } from 'app/models/dataPackGroup.model';
import { DataPackLine } from 'app/models/dataPackLine.model';
import { LoadingComponent } from 'app/home/paraEmpresas/modalLoading/content.component';

 import * as _ from "lodash";

import { VoiceConsumeService } from 'app/services/voice.consume.service';

/**
 * @author Wesley Mascarenhas
 * @version $Id$
 */
@Component({
  templateUrl: './content.template.html',
  providers: [ConsumeView],
  selector: 'consumeDataComponent5G'

})
export class ConsumeDataComponent5G implements  AfterViewInit, OnInit  {


  @Input() hasOverBalanceMonetaryVoice: boolean;
  @Input() hasHibridService: boolean;
  @Input() countPagnatedGroup: number;


  public static readonly GROUPS_FETCH_SIZE: number = 20; //50
  public static readonly LINES_FETCH_SIZE: number = 20;  //50
  public static readonly GIGA_MIN_BALANCE: number = 0;

  public view: ConsumeView;
  public groups: Array<DataPackGroup> = [];

  public filterValue: string;
  public groupEditionId: string;
  public selectAllLines: boolean;
  public checkItem: boolean;
  public editingLines: boolean;
  public hideButton: boolean = true;
  public hideLinesGroup: boolean = false;
  public originalLines: Array<DataPackLine>;
  public linesSnapshot: Array<DataPackLine>;
  public selectedLines: Map<string, DataPackLine>;
  public selectedGroup: DataPackGroup;

  public groupsFetchSize: number = ConsumeDataComponent5G.GROUPS_FETCH_SIZE;
  public linesFetchSize: number = ConsumeDataComponent5G.LINES_FETCH_SIZE;
  public displayShowMoreGroupsButton: boolean;
  public displayShowMoreLinesButton: Map<number, boolean>;
  public sortingCriteria: string = null;
  public sortingAsc: boolean = true;
  public sortingLineCriteria: string = null;
  public sortingLineAsc: boolean = true;
  public savingLines: boolean;
  public pattern: any = /^[0-9]{0,15}[.*]{0,1}[0-9]{0,1}$/;

  public oldAllocatedQuota: string;
  public oldUnallocatedQuota: string;
  public editingMass: boolean;
  public isData: boolean;
  public filtered: boolean = false;

  public loggedManagerType: string;
  public isClicked:boolean = false;

  public savingLinesQuota: boolean = true;
  public savingLinesFutureQuota: boolean = true;


  constructor(private consumeService: ConsumeService,
              private authenticationService: AuthenticationService,
              private modalService: NgbModal,
              private formBuilder: FormBuilder,
              private alertService: AlertService,
              private bindComponent: BindComponentService) {

  }

  ngOnInit() {
    //console.log("carregou o 5G");
      this.bindComponent.set(BindComponentService.FILTER_ACTIVE_TAB, 'CONSUME_DATA_5G_FILTER'); //ALTERADO
      this.bindComponent.subscribe(BindComponentService.LOADING_DATA_CONSUMPTION_5G,
      data => {
        this.consumeService.loadView("5G", 1, ConsumeDataComponent5G.GROUPS_FETCH_SIZE).subscribe(loadedData => {
      	let dataPackCompanyDetail : any = loadedData;
     	  this.view.dataPackCompanyDetail = dataPackCompanyDetail;
      	this.groups = dataPackCompanyDetail['groupList'];
      	this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
      	this.bindComponent.set(BindComponentService.FRANCHISE_AVAILABLE_DATA_CONSUMPTION_5G, dataPackCompanyDetail.franchiseAvailableData);
      	this.openAcctions();
      },
      err => {
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.alertService.error(err.result, err);
      });
      }
      );

      this.loadView();
    }

  ngAfterViewInit() {
    this.loadView();
    this.bindComponent.subscribe(BindComponentService.FILTER_CONSUMPTION,
     group => {
        this.groups = group;
        this.filtered = true;
        this.hideButton=true;
      }
    );

  }


  public openAcctions() {
    let data = JSON.parse(localStorage.getItem('GET_AUTENTICATED_USER'));
    this.loggedManagerType = data['loggedManagerType'];
  }

  private reset() {
    this.groups = [];

    this.filterValue = '';
    this.groupEditionId = null;
    this.selectedGroup = null;
    this.selectAllLines = false;
    this.checkItem = false;
    this.editingLines = false;
    this.hideButton = true;
    this.hideLinesGroup = false;
    this.originalLines = [];
    this.selectedLines = new Map<string, DataPackLine>();
    this.displayShowMoreGroupsButton = true;
    this.displayShowMoreLinesButton = new Map<number, boolean>();
    this.editingMass = false;
  }

  private openModalLoading() {
    this.modalService.open(LoadingComponent,{
      backdrop: 'static',
      keyboard: false ,
    });
  }

  private loadView() {

    this.openModalLoading();
    this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,true);
    this.reset();
    this.view = new ConsumeView();
    this.bindComponent.set(BindComponentService.LOADING_DATA_CONSUMPTION_5G, true);
    let data  = JSON.parse(localStorage.getItem('GET_AUTENTICATED_USER'));
    this.isData = data['isData'];
  }

  private setGroups(groups: Array<DataPackGroup>, append: boolean) {
    if (!append) {
      this.groups = groups;
    } else {
      Array.prototype.push.apply(this.groups, groups);
    }

  }

  private setLines(group: DataPackGroup, lines: Array<DataPackLine>, append: boolean) {
    if (!append) {
      group.lines = lines;
    } else {
      Array.prototype.push.apply(group.lines, lines);
    }

  }



  private searchText(text: string, value: string) {
    return (text && value) ? text.toLowerCase().search(value.toLowerCase()) != -1 : false;
  }

  private toggleGroup(group: DataPackGroup) {
    if(this.editingLines){
      this.cancelLinesEdition(this.selectedGroup);
    }
    if(!this.selectedGroup || this.selectedGroup.id !== group.id) {
      this.selectedGroup = group;
    } else {
      this.selectedGroup = null;
    }
    this.selectedLines.clear();
    this.selectAllLines = false;
    this.hideButton = true;
    this.hideLinesGroup = false;
  }

  private selectAll($event) {
    this.isClicked = false;
    this.checkItem = false;
    this.selectedLines.clear();
    this.selectAllLines = $event.srcElement.checked;
    if (this.selectAllLines == true) {
      this.selectedGroup.lines.forEach(line => {
        if(!line.blockConsumptionStatus || line.blockConsumptionStatus == null) {
          this.selectedLines.set(line.lineNumber, line);
        }
      });
    if(this.selectedLines.size>=2){
      this.editingMass = true;
      }
    }else {
        this.editingMass = false;
    }
  }

  private selectOne($event, line: DataPackLine) {
    this.checkItem = true;
    this.isClicked = false;
    if ($event.srcElement.checked == true) {
        this.selectedLines.set(line.lineNumber, line);
        if(this.selectedLines.size>=2){
          this.editingMass = true;
        }else{
        this.editingMass = false;
        }
    } else {
      this.selectedLines.delete(line.lineNumber);
      if( this.selectedLines.size < 2){
        this.editingMass = false;
      }
    }
  }

  private canCreateGroup(): boolean {
    return this.authenticationService.authenticatedUser && this.authenticationService.authenticatedUser.loggedManagerType === 'COMPANY_MANAGER' || this.authenticationService.authenticatedUser.loggedManagerType === 'COMPANY_MASTER_MANAGER' ;
  }

  private openCreateModal(dataPackCompanyValue: string) {
    let modalRef = this.modalService.open(SaveConsumeComponent,{
    	backdrop: 'static',
    	keyboard: false
    });
    modalRef.componentInstance.model = { group: new DataPackGroup(), managersList: this.view.dataPackCompanyDetail.managersList, franchiseAvailableData: this.view.dataPackCompanyDetail.franchiseAvailableData };
    modalRef.componentInstance.mode = 'creation';
    modalRef.componentInstance.companyQuotaValue = dataPackCompanyValue;
    modalRef.result.then(result => this.loadView(), reason => null);
  }

  private openEditModal(group: DataPackGroup, dataPackCompanyValue: string) {
    let modalRef = this.modalService.open(SaveConsumeComponent,{
      backdrop: 'static',
      keyboard: false ,
    });
    modalRef.componentInstance.mode = 'edition';
    modalRef.componentInstance.model = {group: group, managersList: this.view.dataPackCompanyDetail.managersList, franchiseAvailableData5G: this.view.dataPackCompanyDetail.franchiseAvailableData};
    modalRef.componentInstance.companyQuotaValue = dataPackCompanyValue;
    modalRef.componentInstance.isData = this.isData;
    modalRef.componentInstance.isContextVoice = false;
    modalRef.result.then(result => this.loadView(), reason => null);
  }

  private openRemoveModal(group: DataPackGroup) {
    if(Number(group.totalLines) > 0) {
      this.alertService.error('Grupo tem linhas associadas',null);
    } else {
      let modalRef = this.modalService.open(RemoveGroupConsumeComponent,{
        backdrop: 'static',
        keyboard: false ,
      });
      modalRef.componentInstance.group = group;
      modalRef.result.then(result => this.loadView(), reason => null);
    }
  }

  private openMoveLinesModal() {
    this.isClicked = true;
    if (this.selectedLines.size == 0) {
      this.alertService.warn('Selecione pelo menos uma linha');
      return;
    }

    let payload:any = {
      startRow : 1,
      fetchSize : 10,
      action:'getGroupMoveLines',
      group:this.selectedGroup,
      hasOverBalanceMonetaryVoice:this.hasOverBalanceMonetaryVoice,
      hasHibridService:this.hasHibridService
    }

    this.consumeService.getGroupMoveLines(payload).subscribe(
      data => {
        let groups: Array<DataPackGroup> = data['groupList'];
        let modalRef = this.modalService.open(MoveLineConsumeComponent,{
          backdrop: 'static',
          keyboard: false ,
        });
        modalRef.componentInstance.selectedGroup = this.selectedGroup;
        modalRef.componentInstance.groups = groups;
        modalRef.componentInstance.count = this.countPagnatedGroup;
        modalRef.componentInstance.lines = this.selectedLines;
        modalRef.componentInstance.hasOverBalanceMonetaryVoice = this.hasOverBalanceMonetaryVoice;
        modalRef.componentInstance.hasHibridService = this.hasHibridService;
        modalRef.componentInstance.isConsumeVoice = false;
        modalRef.result.then(result => this.openConfirmationIfNeeded(result), reason => null);
        this.isClicked = false;
      },
      err => {
        this.isClicked = false;
      }
    );
    let data = JSON.parse(localStorage.getItem('GET_AUTENTICATED_USER'));
    this.isData = data['isData'];
  }


  private editQuotaLinesModal() {
    if (this.selectedLines.size == 0) {
      this.alertService.warn('Selecione pelo menos uma linha');
      return;
    }
    let modalRef = this.modalService.open(EditQuotaLinesComponentData5G,{
      backdrop: 'static',
      keyboard: false ,
    });
    modalRef.componentInstance.selectedGroup = this.selectedGroup;
    modalRef.componentInstance.selectedLines = this.selectedLines;
    modalRef.componentInstance.isConsumeVoice = false;
    modalRef.componentInstance.isEditingOverBalance = false;
    modalRef.result.then(result => this.loadView(), reason => null);
  }

    private editNotifLinesModal() {
    if (this.selectedLines.size == 0) {
      this.alertService.warn('Selecione pelo menos uma linha');
      return;
    }
    let modalRef = this.modalService.open(EditNotifLinesComponent,{
      backdrop: 'static',
      keyboard: false ,
    });
    modalRef.componentInstance.selectedGroup = this.selectedGroup;
    modalRef.componentInstance.selectedLines = this.selectedLines;
    modalRef.result.then(result => this.loadView(), reason => null);
  }

  private openConfirmationIfNeeded(result) {
    if (result && result.question == true) {
      let modalRef = this.modalService.open(MoveLineConfirmationComponent,{
        backdrop: 'static',
        keyboard: false ,
      });;
      modalRef.componentInstance.selectedGroup = this.selectedGroup;
      modalRef.componentInstance.groups = this.view.dataPackCompanyDetail.groupList;
      modalRef.componentInstance.lines = this.selectedLines;
      modalRef.componentInstance.message = result.message;
      modalRef.componentInstance.destinationGroupId = result.destinationGroupId;
      modalRef.result.then(result => this.loadView(), reason => null);
    } else {
      this.loadView();
    }
  }

  private editLines(group: DataPackGroup) {
    this.editingLines = true;
    this.originalLines = _.cloneDeep(group.lines);
    this.linesSnapshot = _.cloneDeep(group.lines);
    this.oldAllocatedQuota = group.allocateQuota.value;
    this.oldUnallocatedQuota = group.unallocatedQuota.value;
  }

  private cancelLinesEdition(group: DataPackGroup) {
    this.editingLines = false;
    group.lines = this.originalLines;
    group.allocateQuota.value =  this.oldAllocatedQuota;
    group.unallocatedQuota.value = this.oldUnallocatedQuota;
  }

  private saveLines(group: DataPackGroup) {
    this.savingLines = true;
    let payload = {
      action: 'saveLines',
      sourceGroup: {
        id: group.id
      },
      lines: []
    };
    let linesQuota: number = 0;
    let linesFutureQuota: number = 0;
    let lineQuotaNullFlag: boolean = false;
    let lineFutureQuotaNullFlag: boolean = false;

    group.lines.forEach((line: DataPackLine) => {
      if(!line.blockConsumptionStatus || line.blockConsumptionStatus == null){
      let quota: number = (!_.isNil(line.quota.value) && line.quota.value !== '') ? _.toNumber(line.quota.value) : undefined;
      let futureQuota: number = (!_.isNil(line.futureQuota.value) && line.futureQuota.value !== '') ? _.toNumber(line.futureQuota.value) : undefined;

      if (_.isNil(quota)) {

        lineQuotaNullFlag = true;
      }
      if (_.isNil(futureQuota)) {

        lineFutureQuotaNullFlag = true;
      }
      if(_.isNil(quota)){
        linesQuota = linesQuota + 0;
      }else{
        linesQuota = linesQuota + quota;
      }
      if(_.isNil(futureQuota)){
        linesFutureQuota = linesFutureQuota + 0;
      }else{
        linesFutureQuota = linesFutureQuota + futureQuota;
      }
      line.quota.value = quota? String(quota) : null;
      line.futureQuota.value = futureQuota? String(futureQuota) : null;
      payload.lines.push({
        account: line.account,
        lineNumber: line.lineNumber,
        userName: line.userName,
        quota: line.quota,
        futureQuota: line.futureQuota,
        blockConsumptionStatus: line.blockConsumptionStatus,
        notifyManagerGroup: line.notifyManagerGroup
      });
    }
  }
  );
    if (lineQuotaNullFlag) {
      this.alertService.error('Existe uma ou mais linhas sem cota configurada. Por favor finalize a configuração dessas linhas.',null);
      this.savingLines = false;
    } else if (linesQuota > _.toNumber(group.quota.value)) {
      this.alertService.error('A soma das cotas atribuídas excede a franquia disponível para este grupo. Por favor reveja as configurações.',null);
      this.savingLines = false;
    } else if (lineFutureQuotaNullFlag) {
      this.alertService.error('Existe uma ou mais linhas sem cota futura configurada. Por favor finalize a configuração dessas linhas.',null);
      this.savingLines = false;
    } else if (linesFutureQuota > _.toNumber(group.quota.value)) {
      this.alertService.error('A soma das cotas futuras atribuídas excede a franquia disponível para este grupo. Por favor reveja as configurações.',null);
      this.savingLines = false;
    } else {
      this.consumeService.save(payload).subscribe(
        data => {
          this.savingLines = false;
          this.editingLines = false;
          this.originalLines = null;
          this.alertService.success(data['result']);
          this.loadView();
        },
        err => {
          this.savingLines = false;
          this.alertService.error(err.result, err);
          this.cancelLinesEdition(group);
        }
      );
    }
  }

  private isLineQuotaValueValid(value: string) {
    return /^[0-9]{0,15}[.*]{0,1}[0-9]{0,1}$/.test(value);
  }

  private isNil(value: any): boolean {
    return _.isNil(value);
  }

  private showMoreGroups(): void {
    this.openModalLoading();
    this.consumeService.listGroups("5G",this.groups.length + 1, this.groupsFetchSize).subscribe(
      data => {
        let value: any = data;
        this.setGroups(value, true);
        if (value.length < this.groupsFetchSize) {
          this.displayShowMoreGroupsButton = false;
        }
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
      },
      err => {
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
        this.alertService.error(err.result, err);
      }
    );
  }

  private showMoreLines(group: DataPackGroup): void {
    this.openModalLoading();
    this.consumeService.listLines(group, group.lines.length + 1, this.linesFetchSize).subscribe(
      data => {
        let value: any = data;
        this.setLines(group, value, true);
        if (value.length < this.linesFetchSize) {
          this.displayShowMoreLinesButton[group.id] = false;
        }
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
      },
      err => {
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
        this.alertService.error(err.result, err);
      }
    );
  }

  private sortColumn(column: string) {
    this.sortingAsc = this.sortingCriteria == column ? !this.sortingAsc : true;
    this.sortingCriteria = column;
    this.groups = _.orderBy(this.groups, [this.sortingCriteria], [this.sortingAsc ? 'asc' : 'desc']);
  }

  private sortLineColumn(group: DataPackGroup, column: string) {
    this.sortingLineAsc = this.sortingLineCriteria == column ? !this.sortingLineAsc : true;
    this.sortingLineCriteria = column;
    group.lines = _.orderBy(group.lines, [this.sortingLineCriteria], [this.sortingLineAsc ? 'asc' : 'desc']);
  }


  private updateQuota(group: DataPackGroup, line: DataPackLine, $event) {
    if(line.quota.value.indexOf(',')) {
      line.quota.value = line.quota.value.replace(',', '.');
    }
    let originalLine = _.find(this.linesSnapshot, ['lineNumber', line.lineNumber]);
    let originalValue = this.isNil(originalLine.quota.value)? 0 : (Number(originalLine.quota.value));
    let unallocatedQuotaGroupOld = this.isNil(this.oldUnallocatedQuota)? 0 : (Number(this.oldUnallocatedQuota));
    let allocatedQuotaGroupOld = this.isNil(this.oldAllocatedQuota)? 0 : (Number(this.oldAllocatedQuota));
    let patt = new RegExp(this.pattern);
    if (patt.test(line.quota.value)) {
      if (line.quota.value) {
        let availableQuota = unallocatedQuotaGroupOld + (Number(originalValue) - Number(line.quota.value));
        if (Number(line.quotaConsumption.value) > Number(line.quota.value)) {
          this.alertService.error('O valor da cota deve ser superior ao valor já consumido. Por favor reveja as configurações.', null);
          this.savingLinesQuota = false;
        } else if (availableQuota < 0 ) {
          this.alertService.error('A soma das cotas atribuídas excede a franquia disponível para este grupo. Por favor reveja as configurações.', null);
          this.savingLinesQuota = false;
        } else {
          //os campos são multiplicados por 10 para eliminar o problema de precisão do javascript:
          group.unallocatedQuota.value = String((unallocatedQuotaGroupOld * 10 - ( (Number(line.quota.value) * 10) - (originalValue * 10))) / 10);
          group.allocateQuota.value = String((allocatedQuotaGroupOld * 10 + ((Number(line.quota.value) * 10) - (originalValue * 10))) / 10);
          this.savingLinesQuota = true;
        }
      }else{
       if(this.isBlank(line.limit.value)) {
          group.unallocatedQuota.value = String((unallocatedQuotaGroupOld * 10 + originalValue * 10) / 10);
          group.allocateQuota.value = String((allocatedQuotaGroupOld * 10 - originalValue * 10) / 10);
          this.savingLinesQuota = false;
        }
      }
    }else{
      this.savingLinesQuota = false;
      this.alertService.error('O valor da cota deve ser preenchido apenas com caracteres válidos. Por favor reveja as configurações.', null);
      $event.srcElement.focus();
    }
    this.validateSaveLines();
  }

  private showLines(group: DataPackGroup) {
    this.editingLines = false;
    this.hideButton = false;
    this.hideLinesGroup = true;
    this.editingMass = false;
    this.selectedLines.clear();
    this.selectAllLines = false;
  }

  private hideLines(group: DataPackGroup) {
    this.editingLines = false;
    this.hideButton = true;
    this.hideLinesGroup = false;
    this.editingMass = false;
    this.selectedLines.clear();
    this.selectAllLines = false;
  }

  private showAndEditLines(group: DataPackGroup) {
    this.showLines(group);
    this.editLines(group);
  }

  private closeNotification(notification: string) {
    if(null !== document.getElementById(notification)) {
      document.getElementById(notification).style.display = "none";
    }
  }

  private hasUnallocatedQuota(unallocatedQuotaValue: string) : boolean {
    return Number(unallocatedQuotaValue) > 0;
  }

  private maskMsisdn(msisdn: string): string {
    if(_.isNil(msisdn)) {
      return '';
    }
    if(msisdn.length == 12) {
      return '('.concat(msisdn.substr(0,3)).concat(') ').concat(msisdn.substring(3,(msisdn.length -4))).concat('-').concat(msisdn.substr(-4,4));
    } else if(msisdn.length == 11) {
      return '('.concat(msisdn.substr(0,2)).concat(') ').concat(msisdn.substring(2,(msisdn.length -4))).concat('-').concat(msisdn.substr(-4,4));
    }
    return msisdn;
  }

  private isBlank(str) {
      return (!str || /^\s*$/.test(str));
  }

private commaToDotFutureQuota(line: DataPackLine, $event ){

  if(line.futureQuota && line.futureQuota.value && line.futureQuota.value.indexOf(',')) {
    line.futureQuota.value = line.futureQuota.value.replace(',', '.');
  }

  let patt = new RegExp(this.pattern);
  if (patt.test(line.futureQuota.value)) {
    if(this.isBlank(line.futureQuota.value)) {
      this.savingLinesFutureQuota = false;
    }else{
      this.savingLinesFutureQuota = true;
    }
  }else{
    this.alertService.error('O valor da cota deve ser preenchido apenas com caracteres válidos. Por favor reveja as configurações.',null);
    $event.srcElement.focus();
    this.savingLinesFutureQuota = false;
  }
  this.validateSaveLines();
 }

 private validateSaveLines() {
  if (this.savingLinesQuota && this.savingLinesFutureQuota) {
    this.savingLines = false;
  } else {
    this.savingLines = true;
  }
}

}



// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/consume/data5G/content.component.ts